import { combineReducers } from "redux";
import { tickets } from "./tickets";

const rootReducer = combineReducers({
    tickets,
})

export default rootReducer;